import { render, staticRenderFns } from "./app-link.vue?vue&type=template&id=67bb7a00&"
import script from "./app-link.vue?vue&type=script&lang=js&"
export * from "./app-link.vue?vue&type=script&lang=js&"
import style0 from "./app-link.vue?vue&type=style&index=0&id=67bb7a00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports